export const CATEGORY_EMOJI = {
  "Belleza y Cuidado": "✨",
  "Salud y Bienestar": "🌿",
  "Fitness": "🏋️",
  "Recuperación": "💆",
  "Iluminación": "💡",
  "Electrónica": "🎧",
  "Mascotas": "🐾",
  "Auto": "🚗",
  "Moda y Accesorios": "👗",
  "Hogar": "🏠",
  "Tendencias": "🔥",
  "Cuidado de la Piel": "✨",
  "Suplementos": "💊",
  "Aromaterapia": "🕯️",
  "Nutrición": "🍵",
};

export const emojiFor = (name) => CATEGORY_EMOJI[name] || "🛍️";
